import type { FieldRenderer } from '@/MyCode/core';
import { CounterRow } from './customRenderer/CounterRow';

/**
 * Renderer for counterRow field type
 * Renders a counter component with increment/decrement buttons
 */
export const renderCounterRow: FieldRenderer = ({
    field,
    value,
    handleChange,
}) => {
    // Extract min and max from field configuration
    const min = field.min !== undefined ? field.min : 0;
    const max = field.max !== undefined ? field.max : Infinity;

    // Ensure value is a number, default to min if not set
    const numericValue = typeof value === 'number' ? value : min;

    return (
        <CounterRow
            label={field.label || field.name}
            value={numericValue}
            onChange={(newValue) => handleChange(field.name, newValue)}
            min={min}
            max={max}
        />
    );
};

export default renderCounterRow;
